import { Component } from '@angular/core';

@Component({
  selector: 'app-vacation-insights',
  templateUrl: './vacation-quota.component.html',
  standalone: false,
})
export class VacationQuotaComponent {}
